import { useEffect, useState } from 'react';

import { Image } from 'expo-image';
import { StyleSheet, View } from 'react-native';

import { useAppTakeoverMenuSection } from '../hooks/use-app-takeover';
import { maybePlayAudioOnce } from '../utils/play-audio-once';

export const AppTakeoverMenuSectionTransition = ({ sectionId }: { sectionId: string }) => {
  const {
    isTakeoverActive,
    transitionPicture,
    transitionAudio,
    transitionPictureTime,
    transitionPictureAudio,
  } = useAppTakeoverMenuSection(sectionId);
  const [transitionHidden, setTransitionHidden] = useState(false);

  useEffect(() => {
    if (!isTakeoverActive) {
      return;
    }
    setTransitionHidden(false); // for if the component is reused on same mount on carousel.
    maybePlayAudioOnce(transitionAudio, 1500);
    maybePlayAudioOnce(transitionPictureAudio, 0);
    const timeout = setTimeout(() => {
      // remove when its done playing to prevent potential issues. (pointer events can get through still though but just in case...)
      setTransitionHidden(true);
    }, transitionPictureTime || 5000);
    return () => clearTimeout(timeout);
  }, [isTakeoverActive, transitionAudio, transitionPictureTime, transitionPictureAudio]);

  if (!isTakeoverActive || transitionHidden) {
    return null;
  }

  return (
    <View style={styles.container} pointerEvents="none">
      <Image source={transitionPicture} style={styles.image} pointerEvents="none" />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    position: 'absolute',
    height: '100%',
    width: '100%',
    zIndex: 9999,
  },
  image: {
    width: '100%',
    height: '100%',
  },
});
